import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "025c5434-39a9-4085-992f-5ed89df9a3ba",
    title: "og-jersey",
    name: "OG Jersey",
    actualPrice: 6499,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682043/AegisStore/products/jerseys/OGJersey_ac9bti.webp",
    aegisAssured: true,
    description: "Jersey of the only back to back two time champions",
    features: [
      "Good for all seasons",
      "Made with 100% polyster",
      "Has two stars - indicating for the two TI wins",
    ],
    discount: 16,
    rating: 4.2,
    count: 45,
    categoryName: "jersey",
    sellingPrice: 5459.16,
  },
  {
    _id: "7cdf28da-3e7e-429f-9289-512fdeaa04f4",
    title: "nigma-jersey",
    name: "Nigma Jersey",
    actualPrice: 5999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682043/AegisStore/products/jerseys/NigmaJersey_frzs49.webp",
    aegisAssured: true,
    description: "The original colors of Team Nigma",
    features: [
      "Made with 100% coolmax polyster",
      "Machine washable and Machine dryable",
      "Made in EU",
    ],
    discount: 16,
    rating: 3.8,
    count: 24,
    categoryName: "jersey",
    sellingPrice: 5039.16,
  },
  {
    _id: "d49d3e00-0349-4da8-92c3-f0a3528cb056",
    title: "og-sweathsirt",
    name: "OG Sweatshirt",
    actualPrice: 9499,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682090/AegisStore/products/hoodies/OGJacket_m6aett.webp",
    aegisAssured: false,
    description: "The original OG Pro Jacket",
    features: [
      "100% Polyester",
      "Regular Fit",
      "Jacquard badge OG Logo and embroidered Aegis iconography",
    ],
    discount: 11,
    rating: 3.9,
    count: 8,
    categoryName: "hoodie",
    sellingPrice: 8454.11,
  },
  {
    _id: "5c88d6ea-377b-4f97-9f4a-32d5c2af2fa3",
    title: "razer-eyboard",
    name: "Razer Keyboard",
    actualPrice: 4999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647683341/AegisStore/products/keyboards/RazerKeyboard_kwqldy.webp",
    aegisAssured: false,
    description: "Optical Gaming Keyboard with Near-zero Input Latency",
    features: [
      "Razer™ Linear Optical Switches Gen-2",
      "Doubleshot PBT Keycaps",
      "Sound Dampening Foam",
      "Razer Chroma™ RGB customizable backlighting with 16.8 million color options",
    ],
    discount: 20,
    rating: 2.5,
    count: 10,
    categoryName: "keyboard",
    sellingPrice: 3999.2,
  },
  {
    _id: "b3c9f4c5-6680-4a0a-afd8-7d95b2fddf56",
    title: "astralis-hoodie",
    name: "Astralis Hoodie",
    actualPrice: 9499,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682090/AegisStore/products/hoodies/Astralis_h9wuju.webp",
    aegisAssured: false,
    description: "Colors of the Danish Powerhouse",
    features: [
      "80% cotton, 20% polyester",
      "Regular Fit",
      "Large-scale Astralis logo woven into the jersey",
      "Hood with adjustable drawstring",
      "Ribbed hem and sleeve cuffs",
    ],
    discount: 21,
    rating: 2.9,
    count: 4,
    categoryName: "hoodie",
    sellingPrice: 7504.21,
  },
  {
    _id: "5ba25d30-5a1d-4491-9154-23976fb5eb57",
    title: "eg-jersey",
    name: "EG Jersey",
    actualPrice: 5499,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682043/AegisStore/products/jerseys/EgJersey_fu5hq1.webp",
    aegisAssured: true,
    description:
      "Offical team Jersey of Evil Geniuses the North American Powerhouse",
    features: [
      "Premium materials and feel",
      "Slick feel, short sleeve, breathable make",
      "100% polyster sublimation",
      "Lightweight, high-quality fabric",
      "Made in USA",
    ],
    discount: 21,
    rating: 3.9,
    count: 20,
    categoryName: "jersey",
    sellingPrice: 4344.21,
  },
  {
    _id: "c564a0ef-bf9d-4ee8-8108-96141ef25148",
    title: "logitech-eyboard",
    name: "Logitech Keyboard",
    actualPrice: 2999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647683341/AegisStore/products/keyboards/LogitechKeyboard_jf946c.webp",
    aegisAssured: false,
    description: "Logitech Pro-Inspired Keyboard",
    features: [
      "GX Blue Clicky mechanical switches",
      "LIGHTSYNC RGB lighting",
      "12 programmable F-keys",
      "1 ms report rate",
      "Convenient USB charge port & Detachable Micro USB",
    ],
    discount: 21,
    rating: 4.3,
    count: 50,
    categoryName: "keyboard",
    sellingPrice: 2369.21,
  },
  {
    _id: "fb7cf983-dfff-4800-9c5b-24e7f08d3565",
    title: "team-liquid-hoodie",
    name: "Team Liquid Hoodie",
    actualPrice: 10999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647750565/AegisStore/products/hoodies/TeamLiquidHoodie_xf39pk.webp",
    aegisAssured: true,
    description: "Official Performance Products of Team Liquid Athletes",
    features: [
      "100% Athletic Grade Polyester",
      "Fully Sublimated Design",
      "Made in the USA",
      "Machine Washable",
      "Regular Fit",
    ],
    discount: 21,
    rating: 4.5,
    count: 31,
    categoryName: "hoodie",
    sellingPrice: 8689.21,
  },
  {
    _id: "af4f7d35-308c-4661-b5b4-980a6613205c",
    title: "hyper-x-keyboard",
    name: "HyperX Keyboard",
    actualPrice: 4499,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647683341/AegisStore/products/keyboards/HyperXKeyboard_telwpp.webp",
    discount: 11,
    description: "HyperX Alloy FPS RGB Mechanical Gaming Keyboard",
    features: [
      "RGB backlit keys with radiant lighting effects",
      "Advanced customisation using HyperX NGenuity software",
      "Durable solid-steel frame",
      "Kailh Silver Speed mechanical keyswitches",
      "Convenient USB charge port",
    ],
    rating: 4,
    count: 20,
    categoryName: "keyboard",
    sellingPrice: 4004.11,
  },
  {
    _id: "bc80af7a-351f-40e0-afb2-dd02ba6436a1",
    title: "secret-lab-chair",
    name: "Secret Lab Chair",
    actualPrice: 15999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682690/AegisStore/products/chairs/SecretLabChair_viuvv1.webp",
    aegisAssured: true,
    description: "SecretLab Titan EVO Chair - Voted best Gaming Chair",
    features: [
      "SecretLab Cold Cure Foam",
      "Steel Frame",
      "Machine Embroidery Logo Stictching",
      "Head Rest with Cooling Gel",
      "Four Directional Armrest adjustments",
      "Tilt Lock",
      "Lumbar Support",
    ],
    discount: 41,
    rating: 4.6,
    count: 11,
    categoryName: "chair",
    sellingPrice: 9439.41,
  },
  {
    _id: "c262e416-36dd-4d81-a34d-16beff48a814",
    title: "virtus-pro-jersey",
    name: "Virtus Pro Jersey",
    actualPrice: 4699,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647706874/AegisStore/products/jerseys/VirtusProJersey_qa2o1n.webp",
    aegisAssured: false,
    description: "The official Jersey CIS Region Heavyweights",
    features: [
      "Lightweight",
      "100% original Polyster",
      "Can withstand enough washes",
    ],
    discount: 20,
    rating: 3.6,
    count: 20,
    categoryName: "jersey",
    sellingPrice: 3759.2,
  },
  {
    _id: "9af66067-d497-483f-ac4e-b231998d5ed7",
    title: "nigma-galaxy-hoodie",
    name: "Nigma Galaxy Hoodie",
    actualPrice: 9299,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682090/AegisStore/products/hoodies/NigmaHoodie_d26irz.webp",
    aegisAssured: false,
    description: "The original Hoodie of Team Nigma",
    features: [
      "Made with 100% coolmax polyster",
      "Machine washable and Machine dryable",
      "Made in EU",
      "Regular Fit",
    ],
    discount: 10,
    rating: 4.1,
    count: 20,
    categoryName: "hoodie",
    sellingPrice: 8369.1,
  },
  {
    _id: "ffdf12d7-65e9-48ac-85bf-63b217b48de7",
    title: "team-secret-jersey",
    name: "Secret Jersey",
    actualPrice: 5399,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682044/AegisStore/products/jerseys/SecretJersey_ohi8vy.webp",
    aegisAssured: true,
    description: "The official Jersey Team Secret",
    features: [
      "Ventilated Athletic Mesh Fabric",
      "Standard Fit",
      "100% Polyester",
    ],
    discount: 20,
    rating: 4,
    count: 0,
    categoryName: "jersey",
    sellingPrice: 4319.2,
  },
  {
    _id: "34da7dcc-9a35-4cdc-a33c-ff5fae1f47d4",
    title: "team-secret-Hoodie",
    name: "Team Secret Hoodie",
    actualPrice: 10099,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647753693/AegisStore/products/hoodies/TeamSecretHoodie_gif8bx.webp",
    aegisAssured: true,
    description: "The official Hoodie Team Secret",
    features: ["Standard Fit", "100% Cotton", "Precision Embroidered Logos"],
    discount: 20,
    rating: 2.5,
    count: 20,
    categoryName: "hoodie",
    sellingPrice: 8079.2,
  },
  {
    _id: "84abb9a2-90f6-4a59-92dc-ea8c22410831",
    title: "corsair-chair",
    name: "Corsair Chair",
    actualPrice: 13999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682197/AegisStore/products/chairs/CorsairChiar_wuevyg.webp",
    aegisAssured: true,
    description: "Corsair T3 Gaming Chair",
    features: [
      "Breathable soft body",
      "Padded neck cushion and memory foam lumbar support",
      "Heavy-Duty dual caster wheels",
      "Reclining Backrest",
      "Adjustable seat height",
    ],
    discount: 20,
    rating: 4.3,
    count: 20,
    categoryName: "chair",
    sellingPrice: 11199.2,
  },
  {
    _id: "69ba6940-d3a0-4f37-a17e-fb811bfec16d",
    title: "team-liquid-jersey",
    name: "Team Liquid Jersey",
    actualPrice: 5899,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647750398/AegisStore/products/jerseys/TeamLiquidJersey_jrhswx.webp",
    aegisAssured: true,
    description: "Official Performance Products of Team Liquid Athletes",
    features: [
      "100% Athletic Grade Polyester",
      "Fully Sublimated Design",
      "Made in the USA",
    ],
    discount: 20,
    rating: 2.8,
    count: 20,
    categoryName: "jersey",
    sellingPrice: 4719.2,
  },
  {
    _id: "50c636e3-a376-4652-81ce-71a3ade656f3",
    title: "og-hoodie",
    name: "OG Hoodie",
    actualPrice: 8999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682090/AegisStore/products/hoodies/OGHoodie_pw9jti.webp",
    aegisAssured: true,
    description: "Hoodie of OG - The home of two time TI champions",
    features: [
      "Zip-up Hoodie",
      "88% Cotton, 12% Polyster",
      "Regular Fit",
      "Jacquard badge OG Logo",
    ],
    discount: 8,
    rating: 3.6,
    count: 20,
    categoryName: "hoodie",
    sellingPrice: 8279.08,
  },
  {
    _id: "5f5c9535-c447-4d7b-95a0-f11423fc250b",
    title: "fnatic-hoodie",
    name: "Fnatic Hoodie",
    actualPrice: 7299,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682090/AegisStore/products/hoodies/FnaticHoodie_xrkiuj.webp",
    aegisAssured: true,
    description: "The original Merch from Fnatic",
    features: [
      "75% Polyester 25% cotton brushed back fleece",
      "Screen printed logo to left chest",
      "Regular Fit",
      "Made in Turkey",
    ],
    discount: 40,
    rating: 2.5,
    count: 0,
    categoryName: "hoodie",
    sellingPrice: 4379.4,
  },
  {
    _id: "9a1c3a1a-cd22-4f3a-9a68-d214413779b1",
    title: "corsair-keyboard",
    name: "Corsair Keyboard",
    actualPrice: 3999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682170/AegisStore/products/keyboards/CorsairKeyboard_w6jgoo.webp",
    aegisAssured: false,
    description: "CORSAIR STRAFE RGB MK.2 mechanical keyboard",
    features: [
      "CHERRY® MX mechanical switches",
      "Dedicated FPS and MOBA Keycap sets",
      "100% anti-ghosting full key rollover",
      "Dedicated Media control buttons",
      "Convenient USB passthrough Port",
      "Detachable soft wrist rest",
    ],
    discount: 5,
    rating: 4.1,
    count: 20,
    categoryName: "keyboard",
    sellingPrice: 3799.05,
  },
  {
    _id: "8012fc34-4953-4d71-9b9e-d1657153ccd7",
    title: "faze-Hoodie",
    name: "Faze Hoodie",
    actualPrice: 6999,
    imageUrl:
      "https://res.cloudinary.com/dut75albw/image/upload/v1647682090/AegisStore/products/hoodies/FazeHoodie_jlfohe.webp",
    aegisAssured: true,
    description: "Merch from one of the most popular Gaming Houses - Faze Clan",
    features: [
      "50/50 COTTON/POLYESTER",
      "TRUE TO SIZE STANDARD FIT",
      "ALTERNATE LOGO SCREEN PRINT ON FRONT",
    ],
    discount: 5,
    rating: 3.1,
    count: 0,
    categoryName: "hoodie",
    sellingPrice: 6649.05,
  },
];
